'use client';

import { createContext, use } from 'react';
import type { Attachment } from '../types';

interface AttachmentPreviewContextValue {
  onPreview: (attachment: Attachment) => void;
}

const AttachmentPreviewContext =
  createContext<AttachmentPreviewContextValue | null>(null);

export function AttachmentPreviewProvider({
  children,
  onPreview
}: {
  children: React.ReactNode;
  onPreview: (attachment: Attachment) => void;
}) {
  return (
    <AttachmentPreviewContext value={{ onPreview }}>
      {children}
    </AttachmentPreviewContext>
  );
}

export function useAttachmentPreview() {
  return use(AttachmentPreviewContext);
}
